// import node module libraries
import { Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// import MDI icons
import Icon from '@mdi/react';
import { mdiArrowRight, mdiArrowLeft } from '@mdi/js';

const ArticlesCategoryCard = ({ item }) => {
	const { t } = useTranslation(); // useTranslation-Hook

	return (
		<Card className="border mb-4">
			<Card.Body className="p-5">
				{/* category title and description  */}
				<div className="mb-5">
					<h2 className="fw-semi-bold">{t(item.guide_category_title)}</h2>
					<p>{t(item.guide_category_description)}</p>
				</div>
				{/* articles list  */}
				<ListGroup as="ul" bsPrefix="list-unstyled">
					{item.guides.map((guide, index) => {
						return (
							<ListGroup.Item as="li" className="mb-2" bsPrefix=" " key={index}>
								<Link
									to={`/marketing/help-center/guide-single/${item.guide_category_slug}/${guide.guide_slug}?id=${guide.id}`}
									className="text-body"
								>
									<Icon
										path={mdiArrowRight}
										className="me-1 text-muted"
										size={0.6}
									/>
									{t(guide.guide_title)}
								</Link>
							</ListGroup.Item>
						);
					})}
				</ListGroup>
			</Card.Body>
			<Card.Footer>
				<Link to={`/marketing/help-center/guide`} className="link-primary">
					<Icon path={mdiArrowLeft} size={0.6} /> {t('Back to all categories')}
				</Link>
			</Card.Footer>
		</Card>
	);
};
export default ArticlesCategoryCard;
